import React from 'react'
import QrCodeGenerator from 'Components/QrCodeGenerator'

const GenerateQrCode: React.FC = () => {
  return <QrCodeGenerator />
}

export default GenerateQrCode 